import RadioButton from "../RadioButton";

import * as styledElements from "./RadioButtonsStyles";

interface RadioInput {
  value: string;
  label: string;
}

const RadioButtons = ({
  options,
  currentValue,
  onChange,
  styleProps,
}: {
  options: RadioInput[];
  currentValue: string;
  onChange: (newValue: string) => void;
  styleProps?: object;
}) => (
  <>
    {options.map((option) => {
      return (
        <styledElements.Container key={option.value} style={styleProps}>
          <RadioButton
            onChange={() => onChange(option.value)}
            id={option.value}
            checked={option.value == currentValue}
            label={option.label}
            name={option.value}
          />
        </styledElements.Container>
      );
    })}
  </>
);

export default RadioButtons;
